import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuProps, NavItemType } from 'types/menu';

const initialState: MenuProps = {
  openItem: ['dashboard'],
  openComponent: 'buttons',
  drawerOpen: false,
  componentDrawerOpen: true,
  menus: {
    items: []
  }
};

const sanitizeMenuItems = (items: NavItemType[] = []): NavItemType[] => {
  return items.map((item) => {
    const nextItem: NavItemType = { ...item };
    const url = typeof nextItem.url === 'string' ? nextItem.url.trim() : '';
    if (url && /(^|\/)(undefined|null)(\/|$|[?#])/i.test(url)) {
      nextItem.url = undefined;
    }
    if (Array.isArray(nextItem.children)) {
      nextItem.children = sanitizeMenuItems(nextItem.children);
    }
    return nextItem;
  });
};
const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action: PayloadAction<{ openItem: string[] }>) {
      state.openItem = action.payload.openItem;
    },

    activeComponent(state, action: PayloadAction<{ openComponent: string }>) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action: PayloadAction<{ drawerOpen: boolean }>) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action: PayloadAction<{ componentDrawerOpen: boolean }>) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },

    updateMenuList(state, action: PayloadAction<{ items: NavItemType[] }>) {
      state.menus.items = sanitizeMenuItems(action.payload?.items) as any;
    }
  }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer, updateMenuList } = menu.actions;
